var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/types.ts";
export var isGeneralGroupNode = function isGeneralGroupNode(node) {
  return isGeneralGroupNodeWithElementsNode(node) || isGeneralGroupNodeWithGroupsNode(node) || isGeneralGroupNodeEmptyNode(node);
};
export var isGeneralGroupNodeWithElementsNode = function isGeneralGroupNodeWithElementsNode(node) {
  return node.type === 'UserClassifierGroupNode' && node.groupType === 'WithElements';
};
export var isGeneralGroupNodeWithGroupsNode = function isGeneralGroupNodeWithGroupsNode(node) {
  return node.type === 'UserClassifierGroupNode' && node.groupType === 'WithGroups';
};
export var isGeneralGroupNodeEmptyNode = function isGeneralGroupNodeEmptyNode(node) {
  return node.type === 'UserClassifierGroupNode' && node.groupType === 'Empty';
}; //TODO Убрать не нужные в текущем дереве типы

export var getInclusionNodeType = function getInclusionNodeType(type) {
  switch (type) {
    case 'UserClassifierNode':
    case 'AnonymousClassifierNode':
      return 'UserClassifier';

    case 'UserClassifierGroupWithElementsNode':
    case 'UserClassifierEmptyGroupNode':
    case 'UserClassifierGroupWithGroupsNode':
    case 'UserClassifierGroupNode':
      return 'UserClassifierGroup';

    case 'DynamicBaseGroupNode':
      {
        return 'UserClassifierGroup';
      }

    case 'DynamicGeneratedGroupNode':
      {
        return 'UserClassifierGroup';
      }

    case 'BimModelNode':
    case 'BimModelReferenceNode':
      return 'BimModel';

    case 'BimCategoryNode':
    case 'BimCategoryReferenceNode':
      return 'BimCategory';

    case 'BimFamilyNode':
    case 'BimFamilyReferenceNode':
      return 'BimFamily';

    case 'BimStandardSizeNode':
    case 'BimStandardSizeReferenceNode':
      return 'BimStandardSize';

    case 'BimElementNode':
    case 'BimElementReferenceNode':
      return 'BimElement';

    default:
      throw new Error("Unexpected type: ".concat(type));
  }
};
export function getInclusionNodeTypeWithDynamic(type) {
  if (type === 'DynamicBimElementReferenceNode') {
    return 'DynamicBimElementReferenceNode';
  }

  return getInclusionNodeType(type);
}